import { Sunrise, Sunset } from "lucide-react";

export const SunTimesGrid = ({ moon }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="glass-card p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-3 rounded-xl bg-amber-500/20">
          <Sunrise className="w-6 h-6 text-amber-400" strokeWidth={1.5} />
        </div>
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wider font-heading">Sunrise</p>
          <p className="text-2xl font-mono font-bold text-white">
            {moon.sunrise 
              ? new Date(moon.sunrise).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
              : "--:--"}
          </p>
        </div>
      </div>
    </div>

    <div className="glass-card p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-3 rounded-xl bg-orange-500/20">
          <Sunset className="w-6 h-6 text-orange-400" strokeWidth={1.5} />
        </div>
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wider font-heading">Sunset</p>
          <p className="text-2xl font-mono font-bold text-white">
            {moon.sunset 
              ? new Date(moon.sunset).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
              : "--:--"}
          </p>
        </div>
      </div>
    </div>
  </div>
);
